import { SortOrder } from '@approvalmax/ui/src/components';
import { GetTransactions } from 'shared/data/wallets/v1';

import { FilterValues } from '../TransactionsFilter/TransactionsFilter.types';

export enum ColumnId {
    Wallet = 'wallet',
    CreatedDate = 'createdDate',
    Type = 'type',
    Status = 'status',
    Amount = 'amount',
}

export type Transaction = GetTransactions['response']['items'][number];

export type TransactionSort = Record<ColumnId, SortOrder | undefined>;

export interface TransactionsListProps {
    filter: FilterValues;
}
